(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calftalk-loopgroepen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var tools = document.querySelector('[data-groepen-tools]');
    var grid = document.querySelector('[data-groepen-grid]');
    if (!tools || !grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-groepen-card]'));
    if (!cards.length) return;
    tools.hidden = false;

    var countEl = document.querySelector('[data-groepen-count]');
    var emptyEl = document.querySelector('[data-groepen-empty]');
    var state = { areas: {}, days: {}, tags: {} };

    ['data-groepen-day', 'data-groepen-tag'].forEach(function (attr) {
      tools.querySelectorAll('[' + attr + ']').forEach(function (chip) {
        var value = chip.getAttribute(attr);
        var field = attr === 'data-groepen-day' ? 'data-days' : 'data-tags';
        var used = cards.some(function (card) {
          return (card.getAttribute(field) || '').split(' ').indexOf(value) > -1;
        });
        if (!used) chip.hidden = true;
      });
    });

    function activeKeys(bag) {
      return Object.keys(bag).filter(function (k) {
        return bag[k];
      });
    }

    var PAGE_SIZE = 8;
    var shownLimit = PAGE_SIZE;
    var matching = [];
    var moreBtn = document.querySelector('[data-groepen-more]');

    function render() {
      cards.forEach(function (card) {
        card.hidden = true;
      });
      matching.slice(0, shownLimit).forEach(function (card) {
        card.hidden = false;
      });

      var total = matching.length;
      var shown = Math.min(shownLimit, total);
      if (countEl) {
        countEl.textContent =
          total === 0
            ? '0 loopgroepen'
            : shown < total
              ? shown + ' van ' + total + ' loopgroepen'
              : total + (total === 1 ? ' loopgroep' : ' loopgroepen');
      }
      if (moreBtn) {
        var rest = total - shown;
        moreBtn.hidden = rest <= 0;
        if (rest > 0) {
          moreBtn.textContent = 'Toon ' + Math.min(PAGE_SIZE, rest) + ' meer (nog ' + rest + ')';
        }
      }
      if (emptyEl) emptyEl.hidden = total !== 0;
    }

    function apply() {
      var areas = activeKeys(state.areas);
      var days = activeKeys(state.days);
      var tags = activeKeys(state.tags);
      matching = cards.filter(function (card) {
        var cardDays = (card.getAttribute('data-days') || '').split(' ');
        var cardTags = (card.getAttribute('data-tags') || '').split(' ');
        if (areas.length && areas.indexOf(card.getAttribute('data-area')) < 0) return false;
        if (
          days.length &&
          !days.some(function (d) {
            return cardDays.indexOf(d) > -1;
          })
        )
          return false;
        if (
          !tags.every(function (t) {
            return cardTags.indexOf(t) > -1;
          })
        )
          return false;
        return true;
      });
      shownLimit = PAGE_SIZE;
      render();
    }

    tools.addEventListener('click', function (ev) {
      var chip = ev.target.closest('button');
      if (!chip) return;
      var bag;
      var key;
      if (chip.hasAttribute('data-groepen-area')) {
        bag = state.areas;
        key = chip.getAttribute('data-groepen-area');
      } else if (chip.hasAttribute('data-groepen-day')) {
        bag = state.days;
        key = chip.getAttribute('data-groepen-day');
      } else if (chip.hasAttribute('data-groepen-tag')) {
        bag = state.tags;
        key = chip.getAttribute('data-groepen-tag');
      } else {
        return;
      }
      var on = chip.getAttribute('aria-pressed') === 'true';
      chip.setAttribute('aria-pressed', String(!on));
      bag[key] = !on;
      apply();
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        shownLimit += PAGE_SIZE;
        render();
      });
    }

    apply();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
